import { createFrontendPlugin } from '@backstage/frontend-plugin-api';
import { browsePage } from '../browse';
import { oldTasksPage, requestsPage } from '../requests';
import { groupPageRedirect, userPageRedirect } from '../people';

/**
 * The portal's own pages, as a plugin rather than modules on `app`.
 *
 * `title` is what PluginHeader renders as the first breadcrumb — the docs put
 * it plainly: "The display title of the plugin, used in page headers and
 * navigation. Falls back to the plugin ID if not provided." Registered as
 * modules on pluginId 'app', these pages fell back to the id and the trail
 * read "app > My requests".
 *
 * With the plugin titled Catalog, the trail comes out as Catalog for the
 * browse page — no breadcrumb entry needed, since the plugin title already is
 * that crumb. Exactly how
 * the scaffolder produces "Create › Start".
 *
 * The other modules stay on pluginId 'app' on purpose: they OVERRIDE core app
 * extensions (nav, theme, sign-in), which only works from that plugin.
 *
 * The two redirects are pages in the same sense — they claim a path — even
 * though all they do is leave it. See ../people for why the portal has no
 * person or team page for them to claim.
 */
export const portalPlugin = createFrontendPlugin({
  pluginId: 'codeops',
  title: 'Catalog',
  extensions: [
    browsePage,
    requestsPage,
    oldTasksPage,
    groupPageRedirect,
    userPageRedirect,
  ],
});
